<template>
  <div class="flex items-center space-x-2 py-2">
    <Skeleton class="h-12 w-12 shrink-0 rounded-full" />
    <div class="space-y-2">
      <Skeleton class="h-4 w-[120px]" />
      <Skeleton class="h-4 w-[80px]" />
    </div>
  </div>
</template>

<script setup lang="ts"></script>
